export const AT_LEAST_8_CHARACTER = /^.{8,}$/
export const AT_LEAST_U_AND_L_CHARACTER = /^(?=.*?[A-Z])(?=.*?[a-z]).{1,}$/
export const AT_LEAST_ONE_NUMBER = /^(?=.*?[0-9]).{1,}$/
export const AT_LEAST_ONE_SPECIAL = /^(?=.*?[#?!@$%^&*-]).{1,}$/
export const ONLY_LETTERS_WITH_SPACE = new RegExp("^[a-zA-Z ]+$")